// extracted by mini-css-extract-plugin
export var buttonText = "components-modals-__LanguageConfirmation-module___buttonText";
export var closeButtonText = "components-modals-__LanguageConfirmation-module___closeButtonText";
export var header = "components-modals-__LanguageConfirmation-module___header";
export var lowerTitleText = "components-modals-__LanguageConfirmation-module___lowerTitleText";